import Vue from 'vue'

export async function getProveedores(context, [access_token, params, con_loading]) {

    try {
        if (access_token) {
            if (con_loading) {
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/proveedores',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: params
            })

            context.commit('proveedores/setProveedores', response.data.data, { root: true })
            context.commit('proveedores/setTotalProveedores', response.data.meta.total, { root: true })

        }

    } catch (e) {
    } finally {
        if (con_loading) {
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function getProveedor(context, [access_token, proveedor_id, con_loading]) {

    try {
        if (access_token && proveedor_id) {
            if (con_loading) {
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/proveedores/' + proveedor_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })

            if (response.data?.data) {
                context.commit('proveedores/setProveedorSelec', response.data.data, { root: true })
            }

            return response.data?.data || response.data
        }

    } catch (e) {
    } finally {
        if (con_loading) {
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function getTarifasProveedorPorFecha(context, [access_token, proveedor_id, fecha, con_loading]) {

    try {
        if (access_token && proveedor_id && fecha) {
            if (con_loading) {
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/proveedores/' + proveedor_id + '/tarifas-por-fecha',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: {
                    fecha,
                }
            })

            return response.data?.data || response.data
        }

    } catch (e) {
    } finally {
        if (con_loading) {
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function getMaestrasProveedores(context, [access_token, con_loading]) {

    try {
        if (access_token) {
            if (con_loading) {
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/getMaestrasProveedores',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            context.commit('proveedores/setMaestrasProveedores', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        if (con_loading) {
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function getProveedoresDeServicios(context, [access_token, con_loading]) {

    try {
        if (access_token) {
            if (con_loading) {
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/getProveedoresDeServicios',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            context.commit('proveedores/setProveedoresDeServicios', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        if (con_loading) {
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function getListProveedoresFiscales(context, [access_token]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'GET',
                url: '/getListProveedoresFiscales',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })

            return response.data?.proveedores || response.data?.data || []
        }
    } catch (e) {
        console.error('Error al obtener listado de proveedores fiscales:', e)
        throw e
    } finally {
    }
}



export async function crearProveedor(context, [access_token, modelProveedor]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/proveedores',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelProveedor
            })

            if ((response.status == 201 || response.status == 200) && response.data) {
                return response.data.data || response.data.proveedor || response.data
            }
            return response.data
        }
    } catch (e) {
        console.error('Error al crear proveedor:', e)
        throw e
    } finally {
        //  context.commit('setLoading', false, { root: true })
    }
}

export async function createProveedor(context, [access_token, payload]) {
    try {
        if (access_token && payload) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/createProveedor',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: payload
            })

            if ((response.status == 201 || response.status == 200) && response.data) {
                return response.data.data || response.data.proveedor || response.data
            }
            return response.data
        }
    } catch (e) {
        console.error('Error al crear proveedor:', e)
        throw e
    } finally {
    }
}

export async function updateProveedor(context, [access_token,
    modelProveedor,
    regimenesSeleccionados,
    tiposHabitacionSeleccionados,
    caracteristicasHabitacionSeleccionadas,
    tarifasAutoGeneradas]) {
    try {
        if (access_token) {

            const response = await Vue.axios({
                method: 'PUT',
                url: '/proveedores/' + modelProveedor.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    modelProveedor,
                    regimenesSeleccionados,
                    tiposHabitacionSeleccionados,
                    caracteristicasHabitacionSeleccionadas,
                    tarifas: tarifasAutoGeneradas,
                }
            })
            if (response.status == 200) {
                context.commit('proveedores/actListProveedores', response.data.data, { root: true })
            }
            return response;
        }

    } catch (e) {
    } finally {
        // context.commit('setLoading', false, { root: true })
    }
}


export async function updateProveedorDatosFiscales(context, [access_token, modelProveedor]) {
    try {
        if (access_token) {

            const response = await Vue.axios({
                method: 'PUT',
                url: '/proveedores/' + modelProveedor.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    modelProveedor
                }
            })
            if (response.status == 200) {
                context.commit('proveedores/actListProveedores', response.data.data, { root: true })
            }
            return response;
            // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        // context.commit('setLoading', false, { root: true })
    }
}



export async function eliminarProveedor(context, [access_token, proveedor_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/proveedores/' + proveedor_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })


            if (response.status == 200) {
                context.commit('proveedores/actDeleteListProveedores', proveedor_id, { root: true })
            }
            return response;

            // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        // context.commit('setLoading', false, { root: true })
    }
}

export async function crearProveedorContacto(context, [access_token, proveedor_id, modelContacto]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/proveedores/' + proveedor_id + '/contactos',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    departamento: modelContacto && modelContacto.departamento != null ? modelContacto.departamento : null,
                    responsable: modelContacto && modelContacto.responsable != null ? modelContacto.responsable : null,
                    telefono: modelContacto && modelContacto.telefono != null ? modelContacto.telefono : null,
                    email: modelContacto && modelContacto.email != null ? modelContacto.email : null,
                }
            })

            if (response.status == 201) {
                return response.data
            }
            return response.data
        }
    } catch (e) {
    } finally {
    }
}

export async function updateProveedorContacto(context, [access_token, proveedor_id, contacto_id, modelContacto]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'PUT',
                url: '/proveedores/' + proveedor_id + '/contactos/' + contacto_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    departamento: modelContacto && modelContacto.departamento != null ? modelContacto.departamento : null,
                    responsable: modelContacto && modelContacto.responsable != null ? modelContacto.responsable : null,
                    telefono: modelContacto && modelContacto.telefono != null ? modelContacto.telefono : null,
                    email: modelContacto && modelContacto.email != null ? modelContacto.email : null,
                }
            })

            if (response.status == 200) {
                return response.data
            }
            return response.data
        }
    } catch (e) {
    } finally {
    }
}

export async function eliminarProveedorContacto(context, [access_token, proveedor_id, contacto_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/proveedores/' + proveedor_id + '/contactos/' + contacto_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })

            if (response.status == 200) {
                return response.data
            }
            return response.data
        }
    } catch (e) {
    } finally {
    }
}

export async function crearProveedorDocumento(context, [access_token, proveedor_id, payload]) {
    try {
        if (access_token && proveedor_id && payload && payload.archivo) {
            const formData = new FormData()
            formData.append('archivo', payload.archivo)
            if (payload.nombre != null && String(payload.nombre).trim() !== '') {
                formData.append('nombre', String(payload.nombre).trim())
            }

            const response = await Vue.axios({
                method: 'POST',
                url: '/proveedores/' + proveedor_id + '/documentos',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: formData
            })

            if (response.status == 201 || response.status == 200) {
                return response.data
            }
            return response.data
        }
    } catch (e) {
        console.error('Error al crear documento de proveedor:', e)
        throw e
    } finally {
    }
}

export async function updateProveedorDocumento(context, [access_token, proveedor_id, documento_id, payload]) {
    try {
        if (access_token && proveedor_id && documento_id && payload) {
            const nombre = payload.nombre != null ? String(payload.nombre).trim() : null
            const archivo = payload.archivo || null

            if (!archivo && (nombre == null || nombre === '')) {
                return null
            }

            const configBase = {
                method: 'PUT',
                url: '/proveedores/' + proveedor_id + '/documentos/' + documento_id,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            }

            let response = null
            if (archivo) {
                const formData = new FormData()
                formData.append('archivo', archivo)
                if (nombre != null && nombre !== '') {
                    formData.append('nombre', nombre)
                }
                response = await Vue.axios({
                    ...configBase,
                    data: formData
                })
            } else {
                response = await Vue.axios({
                    ...configBase,
                    headers: {
                        ...configBase.headers,
                        'Content-Type': 'application/json',
                    },
                    data: {
                        nombre,
                    }
                })
            }

            if (response.status == 200) {
                return response.data
            }
            return response.data
        }
    } catch (e) {
        console.error('Error al actualizar documento de proveedor:', e)
        throw e
    } finally {
    }
}

export async function eliminarProveedorDocumento(context, [access_token, proveedor_id, documento_id]) {
    try {
        if (access_token && proveedor_id && documento_id) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/proveedores/' + proveedor_id + '/documentos/' + documento_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })

            if (response.status == 200) {
                return response.data
            }
            return response.data
        }
    } catch (e) {
        console.error('Error al eliminar documento de proveedor:', e)
        throw e
    } finally {
    }
}

export async function updateRefAlojamientoCorreoIdProveedor(context, [access_token, proveedor_id, ref_alojamiento_correo_id]) {
    try {
        if (access_token && proveedor_id) {
            const response = await Vue.axios({
                method: 'PUT',
                url: '/proveedores/' + proveedor_id + '/ref-alojamiento-correo-id',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    ref_alojamiento_correo_id,
                }
            })

            if (response.status == 200 && response.data) {
                return response.data.proveedor || response.data.data || response.data
            }
            return response.data
        }
    } catch (e) {
        console.error('Error al actualizar ref_alojamiento_correo_id del proveedor:', e)
        throw e
    } finally {
    }
}
